import React from 'react'

interface StatusDisplayProps {
  fps: number;
  resolution: { width: number; height: number };
}

export const StatusDisplay: React.FC<StatusDisplayProps> = ({
  fps,
  resolution,
}) => {
  return (
    <div style={{ color: 'white', fontSize: '12px', fontWeight: 'bold', backgroundColor: 'rgba(255,255,255,0.1)', padding: '4px' }}>
      FPS: {fps} | {resolution.width} x {resolution.height} | {resolution.width > resolution.height ? 'Landscape' : 'Portrait'}
    </div>
  )
}
